<template>
  <div id="SignReceipt_PrintTemplate">
    <section class="logo-area">
      <img src="@/assets/img/print/LOGONAME.png" class="logo"/>

      <div class="logo-title">安家寶互助契約簽收回條</div>
    </section>

    <section class="info-area">
      <table cellspacing="0">
        <tr>
          <td width="12%" align="center" bgcolor="#c6c4c4" class="text-weight-bold">互助單<br/>編號</td>
          <td align="center" class="text-weight-bold">{{ data.number }}</td>
          <td width="12%" align="center" bgcolor="#c6c4c4" class="text-weight-bold">要助人<br/>姓名</td>
          <td align="center" class="text-weight-bold">{{ data.pay_name }}</td>
          <td width="12%" align="center" bgcolor="#c6c4c4" class="text-weight-bold">互助人<br/>姓名</td>
          <td align="center" class="text-weight-bold">{{ data.member_name }}</td>
        </tr>

        <tr>
          <td colspan="6" class="text-weight-bold">
            <div class="sign">
              <div>要助人簽收：________________ </div>

              <div>簽名日期：民國____ 年 ___ 月 ___ 日</div>

              <div>業務員簽收：________________ </div>

              <div>簽名日期：民國____ 年 ___ 月 ___ 日</div>
            </div>
          </td>
        </tr>

        <tr>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">契約<br/>交付日</td>
          <td align="center" class="text-weight-bold"></td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">業務<br/>編號</td>
          <td align="center" class="text-weight-bold">{{ data.sales_number }}</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">業務<br/>姓名</td>
          <td align="center" class="text-weight-bold">{{ data.sales_name }}</td>
        </tr>

        <tr class="short">
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">備註</td>
          <td align="center" colspan="5" class="text-weight-bold">請郵寄或親自交回永豐網路平台股份有限公司,謝謝。</td>
        </tr>
      </table>
    </section>

    <div class="bar-code">
      <img id="barCode_number" />

      <span>{{ data.number }}</span>
    </div>
  </div>
</template>

<script>
import jsbarcode from 'jsbarcode';
import { convertRocDate } from "@/models/HELPERS/common.js";

export default {
  name: 'SignReceipt',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  watch: {
    'data.id': {
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.generateBarcode();
        });
      },
      immediate: false
    }
  },
  data () {
    return {

    }
  },

  mounted() {
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.$nextTick(() => {
        this.generateBarcode();
      });
    },
    convertRocDate,
    generateBarcode() {
      jsbarcode(`#barCode_number`, this.data.number, {
        forat: "CODE39",
        margimnBottom: 5,
        font: "DFKai-sb",
        displayValue: false
      });
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  font-family: DFKai-sb;
}

#SignReceipt_PrintTemplate {
  width: 794px;
  height: 560px;
  .logo-area {
    display: grid;
    grid-template-columns: 1fr 1fr;
    row-gap: 5px;
    margin-bottom: 30px;
    .logo {
      height: 90px;
      width: 380px;
    }
    .logo-title {
      font-size: 26px;
      font-weight: bold;
      margin: auto 0 0 40px;
    }
  }
  .info-area {
    &:not(:last-child) {
      margin-bottom: 25px;
    }
    table {
      width: 100%;
      table-layout: fixed;
      word-wrap: break-word;
      word-break: normal;
      font-size: 18px;
      line-height: 1;
      border: 1px solid #000000;
      tr {
        height: 50px;
        &.short {
          height: 25px;
        }
        td {
          border: 1px solid #000000;
          &.text-weight-bold {
            font-weight: bold;
          }
          .sign {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            row-gap: 60px;
            padding: 30px;
          }
        }
      }
    }
  }
  .bar-code {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    font-size: 14px;
    font-weight: bold;
    width: 200px;
    height: auto;
    margin: 0 60px 0 auto;
    img {
      width: 100%;
      height: 35px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/PrintTemplate/SignReceipt.vue